import helpers from '../../utils/helpers';
import DeviceFwuCharacteristicClient from './deviceFwuCharacteristicClient';

const FWU_MAX_RETRY_COUNT = 5;
let instance = null;

export default class DeviceFwuClient {
    constructor(options) {
        if (options && instance) {
            instance.stop();
            instance = null;
        }

        if (instance) {
            return instance;
        }
        if (!options) {
            throw new Error('DeviceFwuClient is not initialized');
        }

        instance = this;

        this.fwuPackageData = options.fwuPackageData;
        this.fwu_target = options.fwu_target;
        this.sendStatusMessage = options.sendStatusMessage;
        this.onUpgradeProcessing = options.onUpgradeProcessing;
        this.onError = options.onError;

        this.deviceId = options.deviceId;
        this.currentFwuTry = 0;
        this.deviceFwuCharacteristicClient = undefined;

    }

    stop = () => {
        if (this.deviceFwuCharacteristicClient) {
            this.deviceFwuCharacteristicClient.stop();
            this.deviceFwuCharacteristicClient = undefined;
        }
    };

    startFwUpdate = async () => {
        this.deviceFwuCharacteristicClient = new DeviceFwuCharacteristicClient({
            deviceId: this.deviceId,
            fwuPackageData: this.fwuPackageData,
            canRetry: this.currentFwuTry <= FWU_MAX_RETRY_COUNT,
            sendStatusMessage: this.sendStatusMessage,
            onUpgradeProcessing: this.onUpgradeProcessing,
            onError: this.onError,
            retryToUpdateFW: async () => {
                console.debug(`DeviceFwuClient: try to start FWU again: try #${this.currentFwuTry}`);
                this.currentFwuTry = this.currentFwuTry + 1;
                await helpers.timeout(500);
                await this.startFwUpdate();
            },
        });
    };
}
